module.exports = __webpack_public_path__ + "static/Moonlighter0-0a1f12164be5045c55cd4d0274fc3756.webp";